import { useGeneratorStore } from '../generatorStore';
import { api } from '../../lib/api/client';

export default function DoneStep() {
  const { status, reset, publishing, publishedSlug, setPublishing, setPublishedSlug } = useGeneratorStore();
  const pages = status?.pages ?? [];
  const sessionId = status?.sessionId ?? '';

  const goPreview = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('mode', 'editor');
    url.searchParams.set('session', sessionId);
    window.location.href = url.toString();
  };

  const handleRegenerate = () => {
    reset();
  };

  const handlePublish = async () => {
    if (!sessionId) return;
    setPublishing(true);
    try {
      const res = await api.ai.publish(sessionId);
      setPublishedSlug(res.slug);
    } catch (err: any) {
      alert('发布失败: ' + (err.message || '未知错误'));
    } finally {
      setPublishing(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={successIconStyle}>{'\u{1F389}'}</div>
      <h2 style={titleStyle}>绘本生成完成！</h2>
      <p style={subtitleStyle}>
        共 {pages.length} 页，点击下方按钮预览或重新生成
      </p>

      {publishedSlug && (
        <div style={publishedBannerStyle}>
          <div style={{ fontWeight: 600, marginBottom: '6px' }}>🎉 已发布为正式绘本！</div>
          <a href={`/?mode=reader&book=${publishedSlug}`} style={publishedLinkStyle}>
            立即阅读 →
          </a>
        </div>
      )}

      {pages.length > 0 && (
        <div style={pagesGridStyle}>
          {pages.map((p) => (
            <div key={p.page_number} style={pageCardStyle}>
              {p.image_path ? (
                <img src={p.image_path} alt={p.title} style={cardImgStyle} />
              ) : (
                <div style={cardPlaceholderStyle}>{'\u{1F4F7}'}</div>
              )}
              <div style={cardTitleStyle}>{p.title}</div>
            </div>
          ))}
        </div>
      )}

      <div style={actionsStyle}>
        <button onClick={handleRegenerate} style={btnSecondaryStyle}>
          重新生成
        </button>
        <button onClick={handlePublish} disabled={publishing || !!publishedSlug} style={btnPublishStyle}>
          {publishing ? '发布中…' : publishedSlug ? '已发布' : '📢 发布为正式绘本'}
        </button>
        <button onClick={goPreview} style={btnPrimaryStyle}>
          去预览 →
        </button>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  maxWidth: '800px',
  margin: '0 auto',
  padding: '40px 20px',
};

const successIconStyle: React.CSSProperties = {
  fontSize: '56px',
  textAlign: 'center',
  marginBottom: '12px',
};

const titleStyle: React.CSSProperties = {
  fontSize: '28px',
  fontWeight: 'bold',
  color: '#fff',
  marginBottom: '8px',
  textAlign: 'center',
};

const subtitleStyle: React.CSSProperties = {
  fontSize: '14px',
  color: 'rgba(255,255,255,0.5)',
  marginBottom: '36px',
  textAlign: 'center',
};

const pagesGridStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
  gap: '14px',
  marginBottom: '36px',
};

const pageCardStyle: React.CSSProperties = {
  background: 'rgba(255,255,255,0.05)',
  borderRadius: '12px',
  padding: '10px',
  textAlign: 'center',
  border: '1px solid rgba(255,255,255,0.08)',
};

const cardImgStyle: React.CSSProperties = {
  width: '100%',
  height: '100px',
  objectFit: 'cover',
  borderRadius: '8px',
  marginBottom: '8px',
};

const cardPlaceholderStyle: React.CSSProperties = {
  width: '100%',
  height: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '32px',
  borderRadius: '8px',
  marginBottom: '8px',
  background: 'rgba(255,255,255,0.05)',
};

const cardTitleStyle: React.CSSProperties = {
  fontSize: '12px',
  color: 'rgba(255,255,255,0.7)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const actionsStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
};

const btnSecondaryStyle: React.CSSProperties = {
  padding: '12px 28px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.2)',
  background: 'transparent',
  color: 'rgba(255,255,255,0.7)',
  fontSize: '15px',
  cursor: 'pointer',
};

const btnPrimaryStyle: React.CSSProperties = {
  padding: '12px 32px',
  borderRadius: '10px',
  border: 'none',
  background: 'linear-gradient(135deg, #7c4dff 0%, #448aff 100%)',
  color: '#fff',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
};

const publishedBannerStyle: React.CSSProperties = {
  background: 'rgba(94,217,199,0.12)',
  border: '1px solid rgba(94,217,199,0.3)',
  borderRadius: '12px',
  padding: '16px 20px',
  marginBottom: '24px',
  textAlign: 'center',
  color: '#5ed9c7',
  fontSize: '15px',
};

const publishedLinkStyle: React.CSSProperties = {
  color: '#fff',
  textDecoration: 'underline',
  fontWeight: 600,
};

const btnPublishStyle: React.CSSProperties = {
  padding: '12px 24px',
  borderRadius: '10px',
  border: 'none',
  background: '#5ed9c7',
  color: '#0d1026',
  fontSize: '15px',
  fontWeight: 600,
  cursor: 'pointer',
  opacity: 1,
};
